import * as React from "react"
import { Link } from "gatsby"

const SERIES_META = {
  "browser-concurrency": {
    title: "Browser Concurrency",
    description:
      "A practical guide to sharing data and coordinating work across browser threads — tabs, workers, and shared memory.",
  },
  "frontend-system-design": {
    title: "Frontend System Design Interview Prep",
    description:
      "A complete guide to acing frontend system design interviews — from the RADIO framework to real-world component designs asked at FAANG.",
  },
}

const SeriesNav = ({ seriesSlug, currentSlug, seriesPosts }) => {
  if (!seriesSlug || !seriesPosts || seriesPosts.length === 0) return null

  const meta = SERIES_META[seriesSlug] || { title: seriesSlug, description: "" }
  const sorted = [...seriesPosts].sort((a, b) => a.seriesOrder - b.seriesOrder)
  const currentIndex = sorted.findIndex(p => p.slug === currentSlug)
  const partLabel =
    currentIndex >= 0
      ? `Part ${currentIndex + 1} of ${sorted.length}`
      : `${sorted.length} articles`

  const containerStyle = {
    borderLeft: "4px solid #4f46e5",
    background: "#f0f4ff",
    borderRadius: "0 6px 6px 0",
    padding: "1rem 1.25rem",
    marginBottom: "2rem",
    fontFamily: "var(--fontFamily-sans, system-ui, sans-serif)",
  }

  const headingStyle = {
    margin: "0 0 0.75rem 0",
    fontSize: "0.95rem",
    fontWeight: 700,
    color: "#1e1b4b",
    letterSpacing: "-0.01em",
  }

  const listStyle = {
    listStyle: "none",
    padding: 0,
    margin: "0 0 0.75rem 0",
  }

  const footerLinkStyle = {
    fontSize: "0.85rem",
    color: "#4f46e5",
    textDecoration: "none",
    fontWeight: 600,
  }

  return (
    <nav aria-label={`${meta.title} series navigation`} style={containerStyle}>
      <p style={headingStyle}>
        📚 {meta.title} — {partLabel}
      </p>
      <ol style={listStyle}>
        {sorted.map((post, idx) => {
          const isCurrent = post.slug === currentSlug
          const isPast = idx < currentIndex

          const itemStyle = {
            marginBottom: "0.35rem",
            fontSize: "0.9rem",
            display: "flex",
            alignItems: "baseline",
            gap: "0.4rem",
          }

          const indicator = isCurrent ? "→" : isPast ? "✓" : "\u00a0\u00a0"

          const indicatorStyle = {
            flexShrink: 0,
            width: "1.2em",
            color: isCurrent ? "#4f46e5" : isPast ? "#6b7280" : "#9ca3af",
            fontWeight: isCurrent ? 700 : 400,
          }

          if (isCurrent) {
            return (
              <li key={post.slug} style={itemStyle} aria-current="page">
                <span style={indicatorStyle}>{indicator}</span>
                <strong style={{ color: "#1e1b4b" }}>
                  {idx + 1}. {post.title}
                </strong>
              </li>
            )
          }

          return (
            <li key={post.slug} style={itemStyle}>
              <span style={indicatorStyle}>{indicator}</span>
              <Link
                to={post.slug}
                style={{
                  color: isPast ? "#6b7280" : "#4f46e5",
                  textDecoration: "none",
                }}
              >
                {idx + 1}. {post.title}
              </Link>
            </li>
          )
        })}
      </ol>
      <Link to={`/series/${seriesSlug}/`} style={footerLinkStyle}>
        View all articles in this series →
      </Link>
    </nav>
  )
}

export default SeriesNav
